import { render, staticRenderFns } from "./BoaViagem.vue?vue&type=template&id=def398e6&scoped=true&"
import script from "./BoaViagem.vue?vue&type=script&lang=js&"
export * from "./BoaViagem.vue?vue&type=script&lang=js&"
import style0 from "./BoaViagem.vue?vue&type=style&index=0&id=def398e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def398e6",
  null
  
)

export default component.exports